<template>
  <div class="parallelForum" id="parallelForum" @mouseenter="mouseEnter" @mouseleave="mouseLeave">
    <div class="header" :style="{backgroundColor:isInParallelForumBox?'#ff3c00':'#fff'}">
      <div style="margin-top: 2vh">
        <img src="https://summit-img.geekpark.net/IFX-LOGO-%E5%8F%8D%E7%99%BD.svg" style="width: 11vh"
             v-if="isInParallelForumBox">
        <img src="https://summit-img.geekpark.net/IFX-10th%20logo.svg" style="width: 11vh" v-else>
      </div>
      <div>
        <img src="https://summit-img.geekpark.net/ifx/pc/v2-%E5%B9%B3%E8%A1%8C%E8%AE%BA%E5%9D%9B-%E7%99%BD.svg"
             style="width: 8vh" v-if="isInParallelForumBox">
        <img src="https://summit-img.geekpark.net/ifx/pc/v2-%E5%B9%B3%E8%A1%8C%E8%AE%BA%E5%9D%9B.svg"
             style="width: 8vh" v-else>
      </div>
      <div style="margin-bottom: 2vh">
        <img
          src="https://summit-img.geekpark.net/ifx/pc/v2-%E5%B9%B3%E8%A1%8C%E8%AE%BA%E5%9D%9B-%E8%8B%B1%E6%96%87-%E7%99%BD.svg"
          style="width: 9vh;" v-if="isInParallelForumBox">
        <img
          src="https://summit-img.geekpark.net/ifx/pc/v2-%E5%B9%B3%E8%A1%8C%E8%AE%BA%E5%9D%9B-%E8%8B%B1%E6%96%87.svg"
          style="width: 9vh;" v-else>
      </div>
    </div>
    <div class="content">
      <a href="https://techday.geekpark.net" target="_blank">
        <img src="https://summit-img.geekpark.net/techday/TECHDAY-%E5%85%A5%E5%8F%A3.png" alt="" style="height: 100%">
      </a>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ParallelForum',
  data () {
    return {
      isInParallelForumBox: false
    }
  },
  methods: {
    mouseEnter () {
      this.isInParallelForumBox = true
    },
    mouseLeave () {
      this.isInParallelForumBox = false
    }
  }
}
</script>

<style scoped lang="less">
  .parallelForum {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 5vh auto 0 6vh;
    box-sizing: border-box;
    height: 90vh;
  }

  .header {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    width: 18vh;
    height: 100%;
    margin: 5vh 0;
    border-left: 1px solid #000;
    border-right: 1px solid #000;
    transition: background-color .3s;
  }

  .content {
    height: 90vh;
    margin-left: 12vh;
    margin-right: 20vh;
  }
</style>
